"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transaction = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _arrowRight = _interopRequireDefault(require("../../assets/images/arrow-right.png"));
var _context = require("../ConfigProvider/context");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Transaction = function Transaction(props) {
  var title = props.title,
    amount = props.amount,
    image = props.image,
    specification = props.specification,
    onClick = props.onClick,
    layout = props.layout,
    status = props.status,
    action = props.action,
    type = props.type;
  var prefixCls = (0, _getPrefixCls.getPrefixCls)('transaction');
  if (layout === 'vertical') {
    return /*#__PURE__*/_react.default.createElement(VerticalTransaction, props);
  }
  var context = (0, _react.useContext)(_context.ConfigContext);
  if (action !== null && action !== void 0 && action.info) {
    action.info.image = image;
  }
  var handleCardClick = function handleCardClick() {
    var _context$eventEmitter, _context$eventEmitter2;
    action && (context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, action === null || action === void 0 ? void 0 : action.func, {
      action: action
    }));
    onClick === null || onClick === void 0 ? void 0 : onClick({
      data: props
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__container"),
    onClick: handleCardClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__image")
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-info")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-info__price")
  }, amount), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-info__name")
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-info__specification")
  }, specification), status && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("".concat(prefixCls, "-status"), "".concat(prefixCls, "-status--").concat(type))
  }, status)));
};
exports.Transaction = Transaction;
var VerticalTransaction = function VerticalTransaction(props) {
  var _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? function () {} : _props$onClick,
    action = props.action,
    status = props.status,
    type = props.type,
    image = props.image;
  var context = (0, _react.useContext)(_context.ConfigContext);
  var prefixCls = (0, _getPrefixCls.getPrefixCls)('transaction-vertical');
  if (action !== null && action !== void 0 && action.info) {
    action.info.image = image;
  }
  var handleCardClick = function handleCardClick() {
    var _context$eventEmitter3, _context$eventEmitter4;
    action && (context === null || context === void 0 ? void 0 : (_context$eventEmitter3 = context.eventEmitter) === null || _context$eventEmitter3 === void 0 ? void 0 : (_context$eventEmitter4 = _context$eventEmitter3.emit) === null || _context$eventEmitter4 === void 0 ? void 0 : _context$eventEmitter4.call(_context$eventEmitter3, action === null || action === void 0 ? void 0 : action.func, {
      action: action
    }));
    onClick === null || onClick === void 0 ? void 0 : onClick({
      data: props
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__container"),
    onClick: handleCardClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__image")
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-info")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-info__name")
  }, props.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-info__specification")
  }, props.specification)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-price__container")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-price")
  }, props.amount), status && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("".concat(prefixCls, "-status"), "".concat(prefixCls, "-status--").concat(type))
  }, status)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-arrow-tail")
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _arrowRight.default
  })));
};